import { ChangeEvent, FocusEvent, forwardRef } from 'react';
import { FormProps } from '../helpers';
import TextInput from '../text-input';

interface Props extends FormProps {
  value: string;
  onChange?: (value: string, event?: ChangeEvent<HTMLInputElement>) => void;
  onEnter?: (value: string) => void;
  onError?: (error: string) => void;
  placeholder?: string;
  maxLength?: number;
}

const HexadecimalInput = forwardRef<HTMLInputElement, Props>(
  ({ disabled, onChange, onBlur, ...rest }, ref) => {
    const handleChange = (value: string, event?: ChangeEvent<HTMLInputElement>) => {
      if (disabled) {
        return;
      }
      onChange?.(String(value).replace(/[^0-9a-fA-F-]+/gi, ''), event);
    };

    const handleBlur = (value: string, event: FocusEvent<HTMLInputElement>) => {
      handleChange(value);
      onBlur?.(value, event);
    };

    return (
      <TextInput
        {...rest}
        disabled={disabled}
        onChange={handleChange}
        onBlur={handleBlur}
        ref={ref}
      />
    );
  }
);

HexadecimalInput.displayName = 'HexadecimalInput';

export default HexadecimalInput;
